import axios from 'axios'

export const downloadContract = async (contractId: string | null | undefined, filename?: string): Promise<void> => {
  if (!contractId) throw new Error('No contract ID provided')
  const panda_access_token = localStorage.getItem('panda_access_token')
  if (!panda_access_token) {
    throw new Error('Not authenticated with PandaDoc — please reconnect from Settings')
  }
  const authHeader =
    import.meta.env.VITE_ENV === 'laptop' ? `API-KEY ${panda_access_token}` : `Bearer ${panda_access_token}`

  const response = await axios.get(`https://api.pandadoc.com/public/v1/documents/${contractId}/download`, {
    headers: {
      Authorization: authHeader,
      'Content-Type': 'application/json',
    },
    responseType: 'blob',
  })

  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename || 'document.pdf')
  document.body.appendChild(link)
  link.click()

  link.parentNode?.removeChild(link)
  window.URL.revokeObjectURL(url)
}
